module.exports = __webpack_public_path__ + "img/setUpCards_5.561d5241.jpg";